import { Flexbox, Typography } from '@doc/ui-components';
import Logo from '@/assets/abb-logo.svg';
import type { HeaderProps } from '../types/header.type';

export const HeaderLogo = ({ title, subtitle }: Pick<HeaderProps, 'title' | 'subtitle'>) => {
	return (
		<Flexbox justify='center' items='center'>
			<Logo />
			<div className='h-8 w-px bg-n300_table_background ml-8 mr-4 my-0' />
			<Flexbox direction='col'>
				<Typography size='text-base' weight='font-medium'>
					{title}
				</Typography>
				<Typography size='text-base' weight='font-light'>
					{subtitle}
				</Typography>
			</Flexbox>
		</Flexbox>
	);
};
